import React, { useCallback, useEffect, useRef, useState } from "react";
import { classes, createClasses, Slider } from "@bloomberg/media-ui-core";

import { ContextualNavItem } from "~components/ContextualNav/ContextualNav";
import { ContextualNavLink } from "~types/types";

import styles from "./styles.module.css";

export type ContextualNavWeekendProps = {
    navItems: ContextualNavLink[];
    currentStoryId?: string;
    trackingFunction?: (eventAction: string, eventLabel: string) => void;
    weekendId?: string;
};

export function WeekendLogo({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="241"
            height="44"
            viewBox="0 0 241 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Weekend Logo"
            role="img"
        >
            <path
                d="M217.979 43.9317C212.241 43.9317 206.845 39.6273 206.845 29.3789C206.845 17.2857 214.496 12.7081 223.581 12.7081C224.879 12.7081 226.518 12.9814 227.68 13.2547C227.68 13.2547 227.68 11.2733 227.68 9.2236V7.72049C227.68 4.98758 227.338 4.78261 225.835 3.89441L223.513 2.66459V1.22981L237.038 0L237.721 0.546584C237.721 0.546584 237.516 3.2795 237.516 7.24223V36.2112C237.516 39.0807 237.653 39.354 239.429 40.1056L241 40.7205V42.2236L228.568 44L227.885 43.5217L228.021 40.1739H227.748C225.289 42.2919 222.215 43.9317 218.116 43.9317H217.979ZM223.171 39.0807C225.289 39.0807 226.792 38.2608 227.543 37.9876V17.4223C226.655 16.2609 225.289 15.0994 223.376 15.0994C219.619 15.0994 216.955 17.9689 216.955 27.3975C216.955 36.8261 219.072 39.0807 223.103 39.0807H223.171Z"
                fill="black"
            />
            <path
                d="M172.075 43.2508V41.6111L173.372 41.2694C175.422 40.7229 175.627 40.4496 175.627 37.9216V20.4993C175.627 18.0396 175.422 17.8347 173.714 16.6049L171.801 15.3067V14.0769L184.575 12.7104L185.259 13.1887L185.122 16.8781H185.327C188.333 14.6235 192.09 12.7104 196.325 12.7104C201.038 12.7104 203.839 15.2384 203.839 20.3626V37.9216C203.839 40.5179 204.044 40.7912 206.093 41.2694L207.391 41.6111V43.2508H190.792V41.6111L192.021 41.3378C193.866 40.7912 193.934 40.7229 193.934 37.9216V22.8222C193.934 19.4744 192.704 18.4496 190.245 18.4496C188.333 18.4496 186.625 18.7912 185.532 18.9962V37.9216C185.532 40.7912 185.668 40.8595 187.444 41.3378L188.674 41.6111V43.2508H172.075Z"
                fill="black"
            />
            <path
                d="M158.481 43.934C148.44 43.934 143.316 38.1266 143.316 28.2881C143.316 18.4496 150.899 12.7104 158.481 12.7104C166.61 12.7104 171.597 16.6732 171.87 26.9899H153.085C153.29 36.2819 156.774 38.6732 162.648 38.6732C165.996 38.6732 168.796 37.7166 170.914 36.5552V38.4682C168.796 40.8595 164.425 43.8657 158.481 43.8657V43.934ZM157.935 14.9651C155.271 14.9651 153.221 17.4931 153.017 24.7353L162.034 24.1887C162.034 17.2881 161.146 14.8968 157.935 14.8968V14.9651Z"
                fill="black"
            />
            <path
                d="M133.685 43.2484C130.406 38.5341 127.537 33.3416 125.556 29.3105V28.2174L131.977 21.3851C133.821 19.3354 134.163 18.1739 134.163 17.1491C134.163 16.1925 133.48 15.646 131.909 15.236L131.089 15.031V13.3913H144.136V15.031L143.043 15.3043C141.54 15.7143 140.652 16.1925 137.988 18.8571L133.001 23.8447C135.939 29.3789 139.764 35.9379 142.36 39.4223C143.043 40.3789 143.726 40.9938 144.683 41.2671L145.502 41.5403V43.1801H133.685V43.2484ZM111.279 43.2484V41.6087L112.577 41.2671C114.626 40.7205 114.831 40.4472 114.831 37.9192V7.72049C114.831 4.85093 114.694 4.50931 112.986 3.68944L111.005 2.66459V1.22981L124.258 0L124.941 0.546584C124.941 0.546584 124.736 3.41615 124.736 7.24223V37.9192C124.736 40.6521 124.941 40.8571 126.649 41.3354L127.673 41.6087V43.2484H111.279Z"
                fill="black"
            />
            <path
                d="M98.5728 43.934C88.531 43.934 83.4077 38.1266 83.4077 28.2881C83.4077 18.4496 90.9902 12.7104 98.5728 12.7104C106.702 12.7104 111.688 16.6732 111.962 26.9899H93.1762C93.3811 36.2819 96.865 38.6732 102.74 38.6732C106.087 38.6732 108.888 37.7166 111.005 36.5552V38.4682C108.888 40.8595 104.516 43.8657 98.5728 43.8657V43.934ZM98.0263 14.9651C95.3621 14.9651 93.3128 17.4931 93.1079 24.7353L102.125 24.1887C102.125 17.2881 101.237 14.8968 98.0263 14.8968V14.9651Z"
                fill="black"
            />
            <path
                d="M67.6289 43.934C57.5872 43.934 52.4639 38.1266 52.4639 28.2881C52.4639 18.4496 60.0464 12.7104 67.6289 12.7104C75.7579 12.7104 80.7446 16.6732 81.0179 26.9899H62.2323C62.4373 36.2819 65.9211 38.6732 71.7959 38.6732C75.1431 38.6732 77.9439 37.7166 80.0615 36.5552V38.4682C77.9439 40.8595 73.572 43.8657 67.6289 43.8657V43.934ZM67.0824 14.9651C64.4183 14.9651 62.369 17.4931 62.164 24.7353L71.1811 24.1887C71.1811 17.2881 70.293 14.8968 67.0824 14.8968V14.9651Z"
                fill="black"
            />
            <path
                d="M15.7115 43.2487L4.85008 10.7953C3.62048 7.17417 3.1423 6.081 1.43453 5.67106L0 5.39777V3.6897H19.4686V5.39777L18.1024 5.73939C16.8728 6.081 16.1897 6.62758 16.1897 7.99404C16.1897 9.22386 16.6679 10.7953 17.2144 12.435L23.0891 31.4288H23.3624L28.4174 15.9195L26.5047 9.77044C25.6849 7.24249 24.9335 6.21765 23.294 5.73939L22.0644 5.39777V3.6897H41.4648V5.39777L39.4154 5.87603C38.1858 6.081 37.6393 6.90088 37.6393 8.19901C37.6393 9.29218 37.9809 10.727 38.5274 12.435L44.4021 31.4288H44.6754L50.2086 12.3667C50.7551 10.7953 51.0283 9.3605 51.0283 8.19901C51.0283 6.69591 50.2086 6.01268 48.9107 5.73939L47.0663 5.39777V3.6897H59.0207V5.39777L57.7911 5.67106C55.8784 6.21765 55.1953 7.92572 53.6924 12.1617L43.7873 43.2487H37.0929L30.0568 20.7021H29.8519L22.406 43.2487H15.5749H15.7115Z"
                fill="black"
            />
        </svg>
    );
}

export const ContextualNavWeekend = (props: ContextualNavWeekendProps) => {
    const { navItems, currentStoryId, trackingFunction, weekendId } = props;

    const [hideSliderArrows, setHideSliderArrows] = useState(false);
    const contextualNavClick = useCallback(() => {
        if (trackingFunction) {
            trackingFunction("click", `weekend_${weekendId}`);
        }
    }, [trackingFunction]);
    const sliderArrowsRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (
            sliderArrowsRef.current &&
            sliderArrowsRef.current.clientWidth ===
                sliderArrowsRef.current.scrollWidth
        ) {
            setHideSliderArrows(true);
        }
    }, []);

    if (!navItems || navItems.length < 1) {
        return null;
    }

    const contextualNavWeekendStyles = classes([
        styles.contextualNavWeekend,
        hideSliderArrows && styles.hideSliderArrows,
    ]);

    return (
        <div className={contextualNavWeekendStyles}>
            <a href="/weekend">
                <WeekendLogo className={styles.desktopLogo} />
            </a>
            <Slider
                className={styles.slider}
                scrollSize={300}
                shadow={false}
                trackRef={sliderArrowsRef}
            >
                <a href="/weekend">
                    <WeekendLogo className={styles.mobileLogo} />
                </a>
                {navItems.map((contextualItem, index) => {
                    const contextualNavTitle =
                        contextualItem.story?.slug ||
                        contextualItem.customUrl ||
                        "weekend";
                    const isCurrentHeadline =
                        contextualItem.story?.id === currentStoryId;
                    const containerStyles = createClasses([
                        styles.contextualNavItemContainer,
                        {
                            [styles.currentHeadline]: isCurrentHeadline,
                        },
                    ]);

                    return (
                        <div className={containerStyles} key={index}>
                            <ContextualNavItem
                                {...contextualItem}
                                contextualNavTitle={contextualNavTitle}
                                itemTitle={contextualItem.title}
                                recordIndex={index}
                                onContextualNavClick={contextualNavClick}
                                isWeekend
                            />
                        </div>
                    );
                })}
            </Slider>
        </div>
    );
};
